(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketingCampaignDeleteController', MarketingCampaignDeleteController);

    MarketingCampaignDeleteController.$inject = ['$uibModalInstance', 'entity', 'MarketingCampaign'];

    function MarketingCampaignDeleteController($uibModalInstance, entity, MarketingCampaign) {
        var vm = this;

        vm.marketingCampaign = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            MarketingCampaign.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
